import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FormattedPrice, I18n } from "@jti/ui";
function isCurrencyObject(currency) {
    return typeof currency === "object" && currency !== null;
}
export const PriceBlockTax = ({ tax, currencyCode, className }) => {
    if (!tax || !Array.isArray(tax)) {
        return null;
    }
    return (_jsx(_Fragment, { children: tax.map(({ label, amount: { currency, value } }) => {
            const displayedCurrencyCode = (isCurrencyObject(currency) ? currency.code : currency) || currencyCode;
            return (_jsx("div", { className: className, children: _jsx(I18n, { t: "cart.prices.incl_taxes", children: _jsx(FormattedPrice, { value: value, currency: displayedCurrencyCode }) }) }, label));
        }) }));
};
//# sourceMappingURL=PriceBlockTax.js.map